<template>
  <div>
    <confirm-email v-if="isPending" :email="email"></confirm-email>
    <div class="login-container" v-else>
      <div class="row p-sm bg-color-login">
        <div class="col-md-12">
          <div class="text-center">
            <h4>パスワードをリセットする</h4>
          </div>
          <div class="alert alert-danger" v-if="err">
            <span id="message" v-html="err"></span>
          </div>
          <div class="hpanel">
            <div class="panel-body">
              <div>
                <span>パスワードをお忘れの場合は、</span><br>
                <span>以下にメールアドレスを入力し、</span><br>
                <span>「パスワードをリセットする」ボタンを押して、</span><br>
                <span>メールを送って下さい。</span>
              </div>
              <br>
              <div class="form-group">
                <label class="control-label label-normal" for="email">メールアドレス</label>
                <input type="text" name="email" id="email" class="form-control" v-model="email" v-validate="'required|email|max:150'" data-vv-as="メールアドレス">
                <span style="display: block" v-show="errors.has('email')" class="text-danger">※{{ errors.first('email') }}</span>
              </div>
              <button class="btn btn-warning btn-block" @click="resetPassword">パスワードをリセットする</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AuthenticationService from '@/services/authenticationservice'
import ConfirmEmail from '@/view/resetpassword/ConfirmEmail'
import msg from '@/common/msg'
export default {
  components: {
    ConfirmEmail
  },
  data () {
    return {
      email: null,
      err: null,
      isPending: false,
      loader: null
    }
  },
  methods: {
    async resetPassword () {
      const self = this
      let validated = await this.$validator.validateAll()
      if (validated) {
        self.loader = this.$loading.show()
        AuthenticationService.resetPassword(self.email)
          .then(response => {
            self.isPending = true
          })
          .catch(error => {
            if (error !== msg.serverErr && typeof error !== 'object') {
              self.err = error
            }
          })
          .finally(() => {
            self.loader.hide()
          })
      }
    }
  },

  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/resetpassword/ResetPassword.vue